// ABI fragments for Bittensor precompiles. See
// packages/contracts/src/endure/interfaces/IBittensorPrecompiles.sol.
export const stakingV2Abi = [
  {
    type: 'function',
    name: 'addStakeLimit',
    stateMutability: 'payable',
    inputs: [
      { name: 'hotkey', type: 'bytes32' },
      { name: 'amountRao', type: 'uint256' },
      { name: 'limitPriceRao', type: 'uint256' },
      { name: 'allowPartial', type: 'bool' },
      { name: 'netuid', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'removeStakeLimit',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'hotkey', type: 'bytes32' },
      { name: 'amountAlpha', type: 'uint256' },
      { name: 'limitPriceRao', type: 'uint256' },
      { name: 'allowPartial', type: 'bool' },
      { name: 'netuid', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'transferStake',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'destinationColdkey', type: 'bytes32' },
      { name: 'hotkey', type: 'bytes32' },
      { name: 'originNetuid', type: 'uint256' },
      { name: 'destinationNetuid', type: 'uint256' },
      { name: 'amount', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'getStake',
    stateMutability: 'view',
    inputs: [
      { name: 'hotkey', type: 'bytes32' },
      { name: 'coldkey', type: 'bytes32' },
      { name: 'netuid', type: 'uint256' },
    ],
    outputs: [{ type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { name: 'spender', type: 'address' },
      { name: 'netuid', type: 'uint256' },
      { name: 'amount', type: 'uint256' },
    ],
    outputs: [],
  },
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { name: 'owner', type: 'address' },
      { name: 'spender', type: 'address' },
      { name: 'netuid', type: 'uint256' },
    ],
    outputs: [{ type: 'uint256' }],
  },
] as const;

export const alphaPrecompileAbi = [
  {
    type: 'function',
    name: 'getAlphaPrice',
    stateMutability: 'view',
    inputs: [{ name: 'netuid', type: 'uint16' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'simSwapTaoForAlpha',
    stateMutability: 'view',
    inputs: [
      { name: 'netuid', type: 'uint16' },
      { name: 'tao', type: 'uint64' },
    ],
    outputs: [{ type: 'uint256' }],
  },
  {
    type: 'function',
    name: 'simSwapAlphaForTao',
    stateMutability: 'view',
    inputs: [
      { name: 'netuid', type: 'uint16' },
      { name: 'alpha', type: 'uint64' },
    ],
    outputs: [{ type: 'uint256' }],
  },
] as const;

export const addressMappingAbi = [
  {
    type: 'function',
    name: 'addressMapping',
    stateMutability: 'view',
    inputs: [{ name: 'targetAddress', type: 'address' }],
    outputs: [{ type: 'bytes32' }],
  },
] as const;
